/* api/linalg.js */ function _(require, module, exports) {
    function __export(m) {
        for (var p in m)
            if (!exports.hasOwnProperty(p))
                exports[p] = m[p];
    }
    __export(require(22) /* ../core/util/object */);
    __export(require(8) /* ../core/util/array */);
    __export(require(25) /* ../core/util/string */);
    __export(require(364) /* ../core/util/random */);
    __export(require(7) /* ../core/util/types */);
    __export(require(15) /* ../core/util/eq */);
}
